export default __webpack_public_path__ + "static/media/eclipse5.5530607a.svg";